import { render, staticRenderFns } from "./buttom.vue?vue&type=template&id=af995174&scoped=true&"
import script from "./buttom.vue?vue&type=script&lang=js&"
export * from "./buttom.vue?vue&type=script&lang=js&"
import style0 from "./buttom.vue?vue&type=style&index=0&id=af995174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af995174",
  null
  
)

export default component.exports